import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-drp',
  templateUrl: './drp.component.html',
  styleUrls: ['./drp.component.scss'],
})
export class DrpComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DrpComponent>,
    public dialog: MatDialog,
  ) {}

  close() {
    this.dialogRef.close();
  }
}
